<template>
<div class="x_box">
    <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/po/invoices">{{ $t('purchase_invoice') }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">[{{ invoice.Num }}]</li>
        </ol>
    <div class="x_header">
        <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
        <template v-if="invoice.Status=='Draft'">
            <router-link :to="{ name: 'po_invoice_update', params: { id: $route.params.id }}" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-pencil"></i> {{$t('edit')}}</router-link>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="onApproval"><i class="fa fa-check"></i> {{ $t('approval') }}</button>
        </template>
        <template v-else>
            <router-link v-if="invoice.Balance>0" :to="{ name: 'purchase_receipt_create', params: { id: $route.params.id }}" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-money"></i> {{$t('purchase_receipt')}}</router-link>
            <router-link v-if="invoice.DocSource=='Manual' && isCompleteStock" :to="{ name: 'purchase_stockin_create', params: { id: $route.params.id }}" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-car"></i> {{$t('stock_in')}}</router-link>
        </template>
    </div>
    <div class="x_body">
        <div class="card f_card">
            <div class="card-body">
                <h3 class="text-center font-m">{{$t('purchase_invoice')}}</h3>
                <p class="text-center">{{$now().format('DD/MM/YYYY HH:mm A')}}</p>
                <div class="row">
                    <div class="col-sm-6">
                        <table class="table-print">
                            <tbody>
                                <tr>
                                    <td style="width: 100px;">{{ $t('vendor') }}</td>
                                    <td style="width: 15px;">:</td>
                                    <td>{{invoice.VendorName}}</td>
                                </tr>
                                <tr>
                                    <td style="width: 100px;">{{ $t('contact') }}</td>
                                    <td style="width: 15px;">:</td>
                                    <td>{{invoice.Contact}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-sm-6">
                        <table class="table-print" align="right">
                            <tbody>
                                <tr>
                                    <td style="width: 100px;">{{$t('invoice_no')}}</td>
                                    <td style="width: 15px;">:</td>
                                    <td>{{invoice.Num}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('date')}}</td>
                                    <td>:</td>
                                    <td>{{$format(invoice.Date, 'DD/MM/YYYY')}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('due_date')}}</td>
                                    <td>:</td>
                                    <td>{{$format(invoice.DueDate, 'DD/MM/YYYY')}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <table class="table table-bordered table-sm no-bor">
                            <thead>
                                <tr>
                                    <th class="text-center" style="width: 50px;">{{$t('no')}}</th>
                                    <th>{{$t('item_name')}}</th>
                                    <th class="text-center" style="width: 100px;">{{$t('qty')}}</th>
                                    <th class="text-center" style="width: 100px;">{{$t('stock_in')}}</th>
                                    <th class="text-center" style="width: 100px;">{{$t('uom')}}</th>
                                    <th class="text-right" style="width: 100px;">{{$t('cost')}}</th>
                                    <th class="text-right" style="width: 100px;">{{$t('tax_line')}}(%)</th>
                                    <th class="text-right" style="width: 100px;">{{$t('sub_total')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(ret,index) in lines" :key="ret.Id">
                                    <td class="text-center">{{index+1}}</td>
                                    <td>{{ret.ItemName}}</td>
                                    <td class="text-center">{{ret.Quantity}}</td>
                                    <td class="text-center" :class="genColor(ret)">{{ret.StockInQty}}</td>
                                    <td class="text-center">{{ret.UomName}}</td>
                                    <td class="text-right">{{$dollar(ret.Price)}}</td>
                                    <td class="text-right">{{ret.TaxLine}}</td>
                                    <td class="text-right">{{$dollar(ret.SubTotal)}}</td>
                                </tr>
                                <tr>
                                    <td colspan="7" class="text-right">{{$t('untax_amount')}}:</td>
                                    <td class="text-right">{{$dollar(invoice.GrandTotal)}}</td>
                                </tr>
                                <tr>
                                    <td colspan="7" class="text-right">{{$t('taxes')}}:</td>
                                    <td class="text-right">{{$dollar(invoice.TaxVat)}}</td>
                                </tr>
                                <tr>
                                    <td colspan="7" class="text-right">{{$t('total')}}:</td>
                                    <td class="text-right">{{$dollar(invoice.PaidAmount)}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <br/>
                <div class="row" v-if="!isLog">
                    <div class="col-sm-12">
                        <button type="button" class="btn btn-outline-primary btn-sm" @click="isLog=true"><i class="fa fa-file-pdf-o"></i> {{ $t('add_file') }}</button>
                    </div>
                </div>
                <br/>
                <div class="row" v-if="isLog">
                    <div class="col-sm-4">
                        <div style="border: 1px solid #ddd; padding: 15px;">
                            <div class="form-group" :class="{ 'form-group-error': $v.model.Description.$error }">
                                <label class="label-control blue">{{$t('description')}}</label>
                                <div>
                                    <textarea type="text" class="form-control form-control-sm" v-model="$v.model.Description.$model"></textarea>
                                </div>
                            </div>
                            <div class="form-group">
                                <div>
                                    <input type="file" ref="file" accept="application/pdf,image/*" style="display: none;" />
                                    <button type="button" class="btn btn-outline-primary btn-sm" @click="$refs.file.click()"><i class="fa fa-paperclip" aria-hidden="true"></i> PDF,IMAGE ONLY</button>
                                </div>
                            </div>
                            <div class="form-group text-right">
                                <button type="button" class="btn btn-outline-danger btn-sm" @click="onCancel"><i class="fa fa-times" aria-hidden="true"></i> {{$t('cancel')}}</button> &nbsp;
                                <button type="button" class="btn btn-outline-success btn-sm" @click="onSaveLog"><i class="fa fa-floppy-o" aria-hidden="true"></i> {{$t('save')}}</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <ul class="list-group list-group-comment">
                            <li v-for="ret in logs" class="list-group-item" :key="ret.Id">
                                <div style="display: flex;">
                                    <div>
                                        <img :src="img" alt="">
                                    </div>
                                    <div style="margin-left: 15px;">
                                        <div class="media-heading blue" style="text-transform: uppercase;">{{ret.CreatedBy}}</div>
                                        <div style="font-size: 12pt;">{{ret.Description}}</div>
                                        <div>{{$format(ret.Date, 'DD-MM-YYYY HH:mm A')}}</div>
                                        <div>
                                            <a href="javascript:void(0)" v-if="ret.FileName!=null">Download</a>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
    import { required } from 'vuelidate/lib/validators'
    export default {
        data: function(){
            return {
                invoice: {
                    Status: '',
                    Balance: 0,
                    DocSource: 'Bill'
                },
                isCompleteStock: true,
                lines: [],
                isLog: false,
                header: {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                },
                model: {
                    DocSource: 'Bill',
                    DocSourceNo: this.$route.params.id,
                    Description: ''
                },
                logs: [],
                img: '/img/64x64.png'
            }
        },
        validations: {
            model: {
                Description: { required }
            }
        },
        created: function(){
            let id = this.$route.params.id;
            if(id != undefined && id != null && id != ''){
                let loading = this.$loading.show();
                this.$api().post('po/invoice/find', { Id: id }).then(res => {
                    var data = res.data.Data;
                    this.invoice = data.POInvoice;
                    this.lines = data.POInvoiceLines;
                    this.calculate();
                }).finally(function(){ loading.hide(); });
            }
        },
        mounted(){
            this.logList();
        },
        methods: {
            onApproval(){
                let id = this.$route.params.id;
                let loading = this.$loading.show();
                this.$api().post('po/invoice/approval', { Id: id }).then(res => {
                    if(this.$isValid(res)){
                        this.$router.go(-1);
                    }
                }).finally(function(){ loading.hide(); });
            },
            calculate(){
                let totalQty = 0;
                let totalStockIn = 0;
                this.lines.forEach(element => {
                    totalQty += Number(element.Quantity);
                    totalStockIn += Number(element.StockInQty);
                });
                this.isCompleteStock = (totalQty - totalStockIn) > 0;
            },
            genColor(item){
                let bg = '';
                if(item.StockInQty == 0) bg = 'bg-danger';
                else if(item.Quantity != item.StockInQty) bg = 'bg-warning';
                return bg;
            },
            onCancel(){
                this.isLog = false;
            },
            onSaveLog(){
                this.$v.$touch();
                if (!this.$v.$invalid) {
                    let loading = this.$loading.show();
                    var formData = new FormData();
                    formData.append('FileLog', this.$refs.file.files[0]);
                    for(var pt in this.model){
                        formData.append(pt, this.model[pt]);
                    }
                    this.$api().post('log/save', formData, this.header).then(res => {
                        if(this.$isValid(res)){
                            this.resetForm();
                        }
                    }).finally(function(){ loading.hide(); });
                }
            },
            logList(){
                this.$api().post('log/list', { Id: this.$route.params.id}).then(res =>{
                    if(this.$isValid(res)){
                        this.logs = res.data.Json.Logs;
                    }
                });
            },
            resetForm(){
                this.model.Description = '';
                this.$v.$reset();
                this.isLog = false;
            }
        }
    }
</script>
<style scoped>
    label{
        margin-bottom: 0;
    }
    .none-left{
        border-left: none;
    }
    .none-bottom{
        border-bottom: none;
        border-top: none;
    }
    .list-group-comment li{
        border-radius: 0 !important;
        margin-bottom: 3px;;
    }
</style>
